import { render, staticRenderFns } from "./IconPen.vue?vue&type=template&id=26a1d8ca"
import script from "./IconPen.vue?vue&type=script&lang=js"
export * from "./IconPen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports